import { Injectable } from '@angular/core'
import { WebService } from '../api/web.service'
import { ServiceUrlConstants } from 'src/app/constants/service-url-constants'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/store/state/app.state'
import {
  getStatusListByCodeFromState,
  getFilteredTaskTypesByModuleAndCategoryAndSubCategoryFromState
} from 'src/app/store/selector/initialize.selector'
import { map, Observable } from 'rxjs'
import { CompanySettingPreferencesAPIModel, TaskTypeAPIModel } from 'src/app/models/api.model'
import { fetch_company_setting_preferences_data } from '../../store/action/initialize.action'

@Injectable({ providedIn: 'root' })
export class InitializeService {
  constructor(private webService: WebService, private appState: Store<AppState>) {
  }

  getInitialSettingsData() {
    return this.webService.get(ServiceUrlConstants.API_INITIALISE)
  }

  getFilteredTaskTypes(module: string, category: string, subCategory: string): Observable<TaskTypeAPIModel[]> {
    return this.appState.select(getFilteredTaskTypesByModuleAndCategoryAndSubCategoryFromState(module, category, subCategory))
  }

  dispatchFetchCompanySettingsData(groupId: string) {
    this.appState.dispatch(fetch_company_setting_preferences_data({ groupId }))
  }

  invokeFetchCompanySettingPreferences(groupId: string) {
    const endPoint = ServiceUrlConstants.createCompanySettingsEndpoint(groupId)
    return this.webService
      .get(endPoint)
      .pipe(map((companySettingPreferences: CompanySettingPreferencesAPIModel) => companySettingPreferences))
  }

  getStatusListByCodeFromState(categoryName, subCategoryName, moduleName, code) {
    return this.appState.select(getStatusListByCodeFromState(categoryName, subCategoryName, moduleName, code))
  }
}
